import Spinner from "@/components/common/spinner";
import { useOrganizationContext } from "@/context";
import { IOrganization } from "@/types/organization";
import { getSelectedTeam } from "@/utils/common";
import { useRouter } from "next/router";
import React, { useEffect } from "react";

export interface IIndexPageProps {}

const IndexPage: React.FC<IIndexPageProps> = () => {
  const router = useRouter();
  const { organizations, isLoading } = useOrganizationContext();

  useEffect(() => {
    if (!isLoading) {
      if (organizations && organizations.length > 0) {
        const selectedTeam = organizations.find(
          (organization) => organization.id === getSelectedTeam()
        );
        if (selectedTeam) {
          router.replace(`/${selectedTeam.slug}`);
        }
        // TODO: remove "as"
        const defaultOrganization = organizations[0] as IOrganization;
        router.replace(`/${defaultOrganization.slug}`);
      } else {
        router.replace("/teams/new");
      }
    }
  }, [router, organizations, isLoading]);

  return <Spinner />;
};

export default IndexPage;
